export const REQUEST_STATUS = {
  IDLE: "idle",
  PENDING: "pending",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;


export const SIGNUP_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
